import axios from "axios";
import { BASE_URL } from "../URL";
import { decryptData, encryptData } from "./encrypt";
import CryptoJS from 'crypto-js';

// const token = "VTJGc2RHVmtYMStUOUg4UkVrY0JGakRZZkhPRTVFRDJpcGlNWmtFRlQ4enVmNURpOGZOcGJUMEtBQ1RyOG1sd2ZLMnh5YmFLUUhwUnB5cVNkeDgvcmJvWVRPMW9ISTJmMVh2MkludzUzY084MktSK0FrTXBGaXN6SCs4SjFvcm5PYlF3eXBBVkE5OWQ3c29FV0p3N24xdTQ4L2VhbmVOM3VKbDB1cjdFNWRpeEtrcmhwSDFHQnQyOENJSUVnNU9uanZyM0VabFBVN1l1cFhJVm9kYU5lczhUaEN1bGdtZlFtelduNnRIQTJFTlVOMHZjUE04SmRnTHVoUlBvNjczR1hscXZhYlllR0pydmd6SElIZDBMdy9scG5uN0NYOE9GSGRRS0dVeWIwTUEzZWI0RkFQbUFxcUlldjc3Z2M0TEFZVThoc01JQm1nbDFGYy8xTkpveXdSM2RRbUdKcS9wU0xKd2dlY2pjR0J4WDhKMm4zbHRpTmVpcUVvUFNqdmpWa2RpTE1CblVBYWxMSnRpaVhyWjZXQT09"
const user_id = "54b4fb48-6962-453b-8891-4d5cc457b574";
// const tenant = "cf913442-417b-4ae4-9921-71814ada603f";
const currentUrl = window.location.href;

const extractParams = (url) => {
  // Extract the query part of the URL (after '?')
  const queryString = url.split('?')[1];

  if (!queryString) {
    return { apiKey: null, token: null }; // Return null if there's no query string
  }

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);

  // Get the apiKey and token
  let apiKey = params.get('apiKey');
  let token = params.get('token');

  // Replace spaces back to '+' (if needed for your use case)
  apiKey = apiKey ? apiKey.replace(/ /g, '+') : null;
  token = token ? token.replace(/ /g, '+') : null;

  return { apiKey, token };
};

const { apiKey, token } = extractParams(currentUrl);
console.log(apiKey,"apiKey",  token, "token", currentUrl);


export const axiosInstance = axios.create({
    baseURL: BASE_URL,
});

// Add an interceptor to include user_id in all requests
axiosInstance.interceptors.request.use((config) => {
    // const token = sessionStorage.getItem("app_name");

    if (token) {
        // Set the Authorization header
        config.headers["x-api-token"] = token;
        config.headers["x-api-key"] = apiKey;
    }

    if (user_id) {
        // Append user_id as a query parameter
        //handling if there are multiple query parameters
        config.params = {
            ...(config.params || {}),
            user_id,
        };
    }

    // Encrypt the payload if it exists
    if (config.data) {
        const encryptedData = encryptData(config.data);
        config.data = {
            encryptedPayload: encryptedData.encryptedPayload,
        }
        config.headers = {
            ...config.headers,
            ...encryptedData.headers,
        };
    }

    return config;
});

// Add a response interceptor to decrypt the response data
axiosInstance.interceptors.response.use((response) => {
    const encryptedPayload = response.data;
    const ivBase64 = response.headers['x-encryption-iv'];
    const receivedHmac = response.headers['x-authentication-mac'];

    if (encryptedPayload && ivBase64 && receivedHmac) {
        const iv = CryptoJS.enc.Base64.parse(ivBase64);
        const decryptedData = decryptData(encryptedPayload, iv, receivedHmac);
        console.log(decryptedData, "encryptedPayload");
        // return decryptedData;
        response.data = decryptedData;
    }


    return response;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;

export const saveAppointment = async (appointmentData) => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/save-appointment-slot`,
            appointmentData
        );
        const appointment = response.data;
        return appointment;
    } catch (error) {
        console.error(error);
    }
};

export const getFacility = async () => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/get-facility-by-tenant`
        );
        const facility = response.data.data;
        return facility;
    } catch (error) {
        console.error(error);
    }
};

export const fetchLookupDataWithName = async (lookup_name) => {
    const tenant = sessionStorage.getItem("tenant_name");
    try {
        const response = await axiosInstance.get(
            `${BASE_URL}configuration-service/reference-lookup/manage-lookup/${tenant}?latest_lookup=${lookup_name}`
        );
        const formCategoryData = response?.data;
        if (formCategoryData.length > 0) {
            const categoriesArray = await Promise.all(
                formCategoryData[0]?.properties[0]?.lookup_values.map(
                    async (valueObject) => {
                        return {
                            value: valueObject?.id,
                            label: valueObject?.value,
                            color: valueObject?.color,
                            code: valueObject?.code,
                        };
                    }
                )
            );
            if (categoriesArray.length > 0) {
                return categoriesArray;
            } else {
                return [];
            }
        }
        return formCategoryData;
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
};

export const getAllDoctorData = async (facility, specialization) => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/get-employee`,
            {
                facility_name: facility,
                employee_type: "Doctor",
                specialization: specialization,
            }
        );
        const doctorData = response.data;
        console.log(doctorData, "doctorData");
        return doctorData;
    } catch (error) {
        console.error(error);
    }
};

export const getSlotData = async (
    doctor_id,
    date,
    facility,
    specialization
) => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/generate-slot`,
            {
                employee_id: doctor_id,
                specialization: specialization.label,
                date: date,
                facility_name: facility.label,
                facility_id: facility.value,
                // specialization: speciality.label
            }
        );

        const slotData = response.data;
        return slotData;
    } catch (error) {
        console.error(error);
    }
};

export const saveAppointmentData = async (appointmentData) => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/save-appointment-slot`,
            appointmentData
        );
        const appointment = response.data;
        return appointment;
    } catch (error) {
        console.error(error);
    }
};

export const getPatientData = async (searchValue, isCheck) => {
    try {
        const response = await axiosInstance.get(
            `patient-service/online-appointment/get-patient-details?search_value=${searchValue}${
                isCheck ? "&&isCheck=true" : ""
            }`
        );
        const patientData = response.data;
        return patientData;
    } catch (error) {
        console.error(error);
    }
};

export const getLookupByName = async ({
    lookupName = "",
    parentLookupName = "",
    parentListValue = "",
}) => {
    try {
        const queryParams = new URLSearchParams({
            user_id: user_id,
            lookup: lookupName,
        }).toString();
        const queryParamsForLookupLink = new URLSearchParams({
            user_id: user_id,
            parent_lookup_name: parentLookupName,
            parent_list_value: parentListValue,
        }).toString();
        const response = await axiosInstance.get(
            `patient-service/online-appointment/get-multi-level-lookup?${
                parentLookupName && parentListValue
                    ? queryParamsForLookupLink
                    : queryParams
            }`
        );

        const lookupData =
            parentLookupName && parentListValue
                ? response.data?.data[0]
                : response.data?.data ?? {};
        const lookupValues = lookupData?.lookup_values ?? [];
        return parentLookupName && parentListValue ? lookupData : lookupValues;
    } catch (error) {
        console.error(error);
    }
};

export const getSelectedEmployeeData = async (employee_id) => {
    try {
        const response = await axiosInstance.get(
            `patient-service/online-appointment/get-data-of-employee?employee_id=${employee_id}`
        );

        const employee = response.data;
        return employee;
    } catch (error) {
        console.error(error);
    }
};

function detectImageType(arrayBuffer) {
    const uint8Array = new Uint8Array(arrayBuffer);
    if (uint8Array.length < 4) {
        return null; // Not enough data to determine image type
    }

    // Check for SVG identifier
    if (
        uint8Array[0] === 60 &&
        uint8Array[1] === 115 &&
        uint8Array[2] === 118 &&
        uint8Array[3] === 103
    ) {
        return "image/svg+xml";
    }

    // Add more checks for other image types here if needed (e.g., JPEG, PNG)

    // Default to generic image type if not recognized
    return "image/*";
}
export const getImage = async (imageId) => {
    if (imageId) {
        const sendKey = await axiosInstance.get(
            `patient-service/online-appointment/get-file/${imageId}`,
            {
                responseType: "arraybuffer",
            }
        );
        if(sendKey.stausCode === 400){
            return;
        }
        const imageType = detectImageType(sendKey.data);
        const blob = new Blob([sendKey.data], { type: imageType });

        // Create a blob URL for the Blob
        const blobUrl = URL.createObjectURL(blob);
        console.log(blobUrl, "blobUrl");
        return blobUrl;
    } else {
        return "";
    }
};

export const getAvailableDoctorList = async (
    facility,
    specialization,
    date,
    employee_id
) => {
    try {
        console.log(
            facility,
            specialization,
            date,
            employee_id,
            "facility, specialization, date, employee_id"
        );

        const queryParams = new URLSearchParams({
            facility_name: facility,
            specialization: specialization,
        });

        if (employee_id) {
            queryParams.append("employee_id", employee_id);
        }

        const response = await axiosInstance.get(
            `patient-service/online-appointment/get-data-of-employee/${encodeURIComponent(date)}?${queryParams.toString()}`
        );

        const doctorData = response.data;
        return doctorData;
    } catch (error) {
        console.error(error);
    }
};


export const savePatientData = async (patientData) => {
    try {
        const response = await axiosInstance.post(
            `patient-service/online-appointment/autogenerate`,
            patientData
        );
        const patient = response.data;
        return patient;
    } catch (error) {
        console.error(error);
    }
};

export const getVisitType = async (
	provider,
	patient,
	appointment_date,
	facility_name,
	facility_id
) => {
	try {
		const response = await axiosInstance.post(
			`patient-service/online-appointment/check-followup`,
			{
				provider_id: provider,
				patient_id: patient,
				appointment_date: appointment_date,
				facility_name: facility_name,
				facility_id: facility_id,
			}
		);
		const appointmentData = response.data;
		return appointmentData;
	} catch (error) {
		console.error(error);
	}
};

export const getConfigurationData = async () => {
	try {
		const response = await axiosInstance.get(
			`patient-service/online-appointment/get-tenant-appointment-configurations`,
		);
		const configurationData = response.data;
		return configurationData;
	} catch (error) {
		console.error(error);
	}
};